import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'v1_stress_level'

const OPTIONS = [
  {
    value: 'Extremely stressed',
    translationKey: 'pages.onboarding.stressLevel.options.extreme',
  },
  {
    value: 'Very stressed',
    translationKey: 'pages.onboarding.stressLevel.options.very',
  },
  {
    value: 'Moderately stressed',
    translationKey: 'pages.onboarding.stressLevel.options.moderate',
  },
  {
    value: 'Slightly stressed',
    translationKey: 'pages.onboarding.stressLevel.options.slight',
  },
  {
    value: 'Not stressed at all',
    translationKey: 'pages.onboarding.stressLevel.options.none',
  },
]

export default function StressLevelPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How much stress does clutter cause you daily?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.stressLevel.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
    />
  )
}
